import React from 'react';
import { View, Text } from 'react-native';
import {FontInfo,  } from '../~Utilities/Constants';
import { Connection, ConnectionMkt } from '../~Utilities/Connection';
import Modal from "react-native-modal";
import LED from '../C_Text/LED';
import ModalEx from './ModalEx';

/*   ---------------------------------------------------------------------   */

export interface ICxtStatus
{
  bindEvent       : (onEvent    : (() => void),
                     bSubscribe : boolean) => void
}

/*   ====================================================================   */

interface IEVTInfoState 
  {
  exit_conf : boolean;
  }

/*   ====================================================================   */


export default class CxtStatus extends React.Component<ICxtStatus>
 {
   state = {visible:false}

   /*   -------------------------------------------------------------------   */
   
    constructor(props)
    {
    super(props);

    this.ShowModal       = this.ShowModal.bind(this);
    this.HideModal       = this.HideModal.bind(this);
    this.renderCxtStatus = this.renderCxtStatus.bind(this);

    this.state = {visible:false};
    }

    /*   ---------------------------------------------------------------------   */

    componentDidMount() 
    {
    }

    componentWillUnmount() 
    {
    }

   /*   ---------------------------------------------------------------------   */ 
   
    componentDidUpdate()
    {
    }

   /*   ---------------------------------------------------------------------   */ 

   ShowModal()
   {
   ModalEx.oModalEx?.Show();
 
   this.setState({
                 visible:true
                  });
   }
 
   /*   -------------------------------------------------------------------   */

   HideModal()
   {
   ModalEx.oModalEx?.Hide();
 
   this.setState({
                 visible:false
                  });
   }
 
   /*   -------------------------------------------------------------------   */
 
   renderCxtStatus()
   {
     return (
       <Modal style={{}}
         useNativeDriver={true}
         useNativeDriverForBackdrop={true}
         backdropOpacity={0.0}
         animationInTiming={400}
         animationOutTiming={250}
         animationIn={"bounceInLeft"}
         animationOut={"slideOutLeft"}
         backdropTransitionOutTiming={0}
         hideModalContentWhileAnimating={true}
         isVisible={this.state.visible}
         onBackdropPress={()=>this.HideModal()}
         >
 
       <View style={{alignSelf:'center', minWidth:200, minHeight:60, padding:20, 
                     justifyContent:'center', alignItems:'center', flexDirection:'column',
                     alignContent:'center', 
                     borderRadius:20, backgroundColor:FontInfo.sBackgroundTp}}>
 
      
       <View style={{flexDirection:'row', marginVertical:5, alignSelf:'center'}}>

        <View style={{flexDirection:'row', marginVertical:5, marginRight:15}}>
        <LED bindEvent={this.props.bindEvent} getCxtState={Connection.GetMktState}
              style={{width:10, marginRight:-1, height:10, borderRadius:5,alignSelf:'center'}}
              />
        <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+4, 
                      color:FontInfo.sForeground, opacity:1, marginLeft:4, marginTop:-2 }]}>Price</Text>
        </View>

        <View style={{flexDirection:'row', marginVertical:5, marginRight:15}}>
        <LED bindEvent={this.props.bindEvent} getCxtState={Connection.GetHisState}
              style={{width:10, marginRight:-1, height:10, borderRadius:5,alignSelf:'center'}}
              />
        <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+4, 
                      color:FontInfo.sForeground, opacity:1, marginLeft:4, marginTop:-2 }]}>Chart</Text>
        </View>        

        <View style={{flexDirection:'row', marginVertical:5, marginRight:15}}>
        <LED bindEvent={this.props.bindEvent} getCxtState={Connection.GetOrdState}
              style={{width:10, marginRight:-1, height:10, borderRadius:5,alignSelf:'center'}}
        />
        <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+4, 
                      color:FontInfo.sForeground, opacity:1, marginLeft:4, marginTop:-2}]}>Order</Text>
        </View>

        <View style={{flexDirection:'row', marginVertical:5}}>
        <LED bindEvent={this.props.bindEvent} getCxtState={Connection.GetRMSState}
              style={{width:10, marginRight:-1, height:10, borderRadius:5,alignSelf:'center'}}
        />
        <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize+4, 
                      color:FontInfo.sForeground, opacity:1, marginLeft:4, marginTop:-2}]}>Risk</Text>
        </View>        
      </View>
 
 
       </View>
 
       {/* </View> */}
       </Modal>
 
     );
   }
 
   /*   -------------------------------------------------------------------   */
 
   render() 
   {
   if (!ConnectionMkt.IsLoggedIn())  
    return(null);
   else return(
      <this.renderCxtStatus/>
      );

     }
}